import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { DataVehiculosService } from '../../../modulos/general/componentes/gestion-vehiculos/services/data-vehiculos.service';

import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'dms-vehicle-select',
    templateUrl: './vehicle-select.component.html',
    styleUrls: ['./vehicle-select.component.scss']
})
export class VehicleSelectComponent implements OnInit, OnDestroy {

    @Output() modalCloseVehicle = new EventEmitter<any>();
    // @Output() modeloCarSearch = new EventEmitter<any>();
    error: string;
    code: string;

    loading: boolean;
    dataFamilyAuto: any;
    dataSiluetaAuto: any;
    dataMotorAuto: any;
    dataTransmission: any;

    dataResolve: any;
    reference: string;

    familyCode: string;
    contourCode: string;
    engineCode: string;
    transmissionCode: string;

    siluetaOption: boolean;
    motorOption: boolean;
    transmissionOption: boolean;

    private modal: NgbModalRef;
    modalOption: NgbModalOptions = {};


    familyAuto = [
        {
            title: '',
            th: ['Modelo', 'LCDV', 'Año', 'Modificación'],
            fields: ['VersionText', 'Version16', 'VersionYear', 'ModYearText'],
            gridView: {}
        }
    ];

    constructor(private toastr: ToastrService, private _authService: AuthService, private _dataVehiculosService: DataVehiculosService, private modalService: NgbModal) {
        this.siluetaOption = true;
        this.motorOption = true;
        this.transmissionOption = true;
        this.loading = false;
    }

    ngOnInit() {
        this.getFamilies();
    }


    getFamilies() {
        const params = { 'searchValue': '' };
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetFamilies`;
        this._dataVehiculosService.getFamilies(_URL_, params).subscribe(data => {
            const auxData = data.Response;
            if (auxData) {
                this.dataFamilyAuto = auxData;
            }
        });
    }

    async silueta() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetContoursByFamilyCode`;
        const params = {
            'searchValue': this.familyCode,
            'orderBy': null
        };
        const combo1Fetch = this._dataVehiculosService.getContours(_URL_, params).subscribe(
            data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.dataSiluetaAuto = auxdata;
                }
            });
        return combo1Fetch;
    }
    async motor() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetEngineByFamilyCode`;
        const params = {
            'searchValue': this.familyCode,
            'orderBy': null
        };
        const combo2Fetch = this._dataVehiculosService.getEngineMotor(_URL_, params).subscribe(
            data => {
                const auxdata = data.Response;
                if (auxdata) {
                    this.dataMotorAuto = auxdata;
                }
            });
        return combo2Fetch;
    }
    async transmision() {
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetTransmissionsByFamilyCode`;
        const params = {
            'searchValue': this.familyCode,
            'orderBy': null
        };
        const combo3Fetch = this._dataVehiculosService.getTransmissionsByFamily(_URL_, params).subscribe(data => {
            const auxdata = data.Response;
            if (auxdata) {
                this.dataTransmission = auxdata;
            }
        });
        return combo3Fetch;
    }
    async onChangeSilueta(event: string) {  // combo1
        this.familyCode = event;
        this.contourCode = ''; // dejo vacio el combo2
        this.engineCode = ''; // dejo vacio el combo3
        this.transmissionCode = ''; // dejo vacio el combo4
        try {
            const combo1 = await this.silueta();
            const combo2 = await this.motor();
            const combo3 = await this.transmision();
            this.getDataTable();
        } catch (error) {
        }
    }
    async onChangeMotor(event: string) {  // combo2
        this.contourCode = event;

        this.engineCode = ''; // dejo vacio el combo3
        this.transmissionCode = ''; // dejo vacio el combo4
        try {

            const combo2 = await this.motor();
            const combo3 = await this.transmision();

            this.getDataTable();
        } catch (error) {
        }
    }
    async onChangeTransmission(event: string) {  // combo3

        this.engineCode = event;
        this.transmissionCode = ''; // dejo vacio el combo4
        try {
            const combo3 = await this.transmision();
            this.getDataTable();
        } catch (error) {
        }

    }

    onChangeLast(event: string) {  // combo4
        this.transmissionCode = event;
        this.getDataTable();
    }



    ngOnDestroy() { }

    onTabSelect(event) { }
    //result es la pantalla
    closeModal(result: any, datos: boolean) {
        if (result && datos) {
            const params = {
                'pantalla': 'vehicleSelectorForm',
                'datosForm': datos
            };
            this.modalCloseVehicle.emit(params);
        } else {
            const params = {
                'pantalla': 'vehicleSelectorForm',
                'datosForm': null
            };
            this.modalCloseVehicle.emit(params);
        }


    }

    getDataTable() {
        this.loading = true;
        const _URL_ = `${environment.ENTORNO}Services/Workshop/VehicleService.svc/GetCarModelsPaged`;
        const params = {
            'description': '',
            'familyCode': this.familyCode,
            'contourCode': this.contourCode,
            'engineCode': this.engineCode,
            'transmissionCode': this.transmissionCode,
            pageInfo: { Number: 1, Size: 20 }
        };

        this._dataVehiculosService.getCarModel(_URL_, params).subscribe(data => {
            const auxData = data.Response.Content;
            if (data.Response) {
                this.dataResolve = auxData;
                this.familyAuto[0]['gridView'] = {
                    data: this.dataResolve,
                    total: this.dataResolve.length
                };
            }
        });
        this.loading = false;
    }



    selectRow(event) {
        const datosForm = event.dataItem;
        this.closeModal('vehicleSelectorForm', datosForm);
        // this.modeloCarSearch.emit(event.dataItem);
    }
}
